// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2fdb038b","732":"bd2c22a8","977":"c690579d"}[chunkId] + ".chunk.js";
};